import axios from "axios";

const axiosConfig = axios.create({
  baseURL: "https://dev.api.bookybook.rs/",
  withCredentials: true,
});

export default axiosConfig;
